import CompoundFeedWizard  from "./CompoundFeedWizard";

export default CompoundFeedWizard;
